export const getAgroupitemStyles = () =>
  ({
    removeArrowButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      '-webkit-transform': 'translate(0, -50%)',
    },

    addArrowButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      '-webkit-transform': 'translate(0, -50%)',
      right: 10,
    },

    itemContainer: {
      display: 'inline-block',
      marginLeft: 20,
      maxWidth: 200,
      overflow: 'hidden',
      whitespace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  });
